import { AddressDTO } from "./AddressDTO";
import { SubscriptionContactsDTO } from "./SubscriptionContactsDTO";

export class CompanyDataDTO {
    companyName: string;
    cnpj: string;
    iE: string;
    address: AddressDTO;
    contacts: SubscriptionContactsDTO;

    constructor(sub?) {
        sub = sub || {};

        this.companyName = sub.companyName || "";
        this.cnpj = sub.cnpj || null;
        this.iE = sub.iE || null;
        this.address = new AddressDTO(sub.address);
        this.contacts = new SubscriptionContactsDTO(sub.contacts);
    }
}
